import { render, staticRenderFns } from "./ModalInfoOnlyInstitute.vue?vue&type=template&id=a5a66634"
import script from "./ModalInfoOnlyInstitute.vue?vue&type=script&lang=js"
export * from "./ModalInfoOnlyInstitute.vue?vue&type=script&lang=js"
import style0 from "./ModalInfoOnlyInstitute.vue?vue&type=style&index=0&id=a5a66634&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports